"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectSizes = void 0;

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./Select.style"));

var ic_doublearrow_9_x_18_gray_600_svg_1 = tslib_1.__importDefault(require("../../assets/ic-doublearrow-9-x-18-gray-600.svg"));

exports.SelectSizes = ['small', 'medium', 'large'];
var Select = react_1.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      name = _ref.name,
      options = _ref.options,
      onChange = _ref.onChange,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$invalid = _ref.invalid,
      invalid = _ref$invalid === void 0 ? false : _ref$invalid,
      invalidCaption = _ref.invalidCaption,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$full = _ref.full,
      full = _ref$full === void 0 ? false : _ref$full;

  var _react_1$useState = react_1.useState(false),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      isFocus = _react_1$useState2[0],
      setFocus = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(value && options.find(function (option) {
    return option.value === value;
  }) || defaultValue && options.find(function (option) {
    return option.value === defaultValue;
  }) || options[0]),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      focusedValue = _react_1$useState4[0],
      setFocusedValue = _react_1$useState4[1];

  var _react_1$useState5 = react_1.useState(false),
      _react_1$useState6 = _slicedToArray(_react_1$useState5, 2),
      isInvalid = _react_1$useState6[0],
      setInvalid = _react_1$useState6[1];

  react_1.useEffect(function () {
    var option = options.find(function (option) {
      return option.value === value;
    });
    option && setFocusedValue(option);
  }, [value, options]);

  function handleOnChange(_ref2) {
    var target = _ref2.target;

    /**
     * iOS 에서는 하단 select UI의 selectedIndex가 다른 selct에서도 유지되며 index가 올바르지 않을 경우
     * (이전에는 7개중 7번째 선택 했으나 다음 select이 option이 5개인 경우) -1을 반환한다.
     * 그에 따른 방어코드
     * */
    if (options.length <= target.selectedIndex || target.selectedIndex === -1) {
      return;
    }

    onChange && onChange(target.value);
    setFocusedValue(options[target.selectedIndex]);
  }

  function handleOnFocus(event) {
    event.stopPropagation();
    setFocus(true);
  }

  function handleOnBlur(event) {
    event.stopPropagation();
    setFocus(false);
  }

  function renderOptions() {
    return options.map(function (_ref3) {
      var value = _ref3.value,
          content = _ref3.content;
      return jsx_runtime_1.jsx("option", Object.assign({
        value: value
      }, {
        children: content
      }), value);
    });
  }

  react_1.useEffect(function () {
    setInvalid(invalid);
  }, [invalid, name, ref]);
  return jsx_runtime_1.jsxs("div", Object.assign({
    css: [full && styles.full]
  }, {
    children: [jsx_runtime_1.jsxs("div", Object.assign({
      css: [styles.wrapper, styles.sizeStyles[size], isFocus && styles.focus, isInvalid && styles.invalid, disabled && styles.disabled, full && styles.full],
      className: className
    }, {
      children: [jsx_runtime_1.jsx("select", Object.assign({
        ref: ref,
        name: name,
        css: styles.originInput,
        onChange: handleOnChange,
        onFocus: handleOnFocus,
        onBlur: handleOnBlur,
        value: focusedValue.value
      }, {
        children: renderOptions()
      }), void 0), jsx_runtime_1.jsxs("div", Object.assign({
        css: styles.content
      }, {
        children: [jsx_runtime_1.jsx("span", Object.assign({
          css: styles.focusText
        }, {
          children: focusedValue.content
        }), void 0), jsx_runtime_1.jsx("img", {
          css: [styles.caretIcon, disabled && styles.disableCaretIcon],
          src: ic_doublearrow_9_x_18_gray_600_svg_1.default,
          alt: "select caret"
        }, void 0)]
      }), void 0)]
    }), void 0), invalid && invalidCaption && jsx_runtime_1.jsx("div", Object.assign({
      css: [styles.caption, styles.invalidCaption]
    }, {
      children: invalidCaption
    }), void 0)]
  }), void 0);
});
exports.default = react_1.memo(Select);